import React, { useEffect, useMemo } from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { usePageMetadata } from "../context/PageMetadataContext";
import { useAuth } from "../context/AuthContext";
import { AppButton } from "../components/ui";
import "./Viewer.scss";

const VIEWER_BASE_URL = process.env.REACT_APP_VIEWER_BASE_URL || "https://viewer.10k.science";

const Viewer = () => {
  const navigate = useNavigate();
  const { experienceId: experienceIdFromPath } = useParams();
  const [searchParams] = useSearchParams();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();
  const { userName, userId, organizationId, subscriptionStatus } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(false);
    setTitle("Viewer");
  }, [setShowTitleInHeader, setTitle]);

  const experienceIdFromQuery = searchParams.get("experienceId");

  const experienceId = useMemo(
    () => experienceIdFromPath || experienceIdFromQuery || "",
    [experienceIdFromPath, experienceIdFromQuery]
  );

  const embedUrl = useMemo(() => {
    if (!experienceId) {
      return "";
    }

    const viewerParams = new URLSearchParams({
      userName: userName || "",
      userId: userId || "",
      organizationId: organizationId || "",
      subscriptionStatus: subscriptionStatus || "",
    });

    console.log(`${VIEWER_BASE_URL}/experiences/embed/${encodeURIComponent(experienceId)}?${viewerParams.toString()}`);
    return `${VIEWER_BASE_URL}/experiences/embed/${encodeURIComponent(experienceId)}?${viewerParams.toString()}`;
  }, [experienceId, userName, userId, organizationId, subscriptionStatus]);

  return (
    <main className="viewerPage">
      <section className="viewerPage__content">
        <div className="viewerPage__overlayControls">
          <AppButton
            className="viewerPage__backButton"
            kind="secondary"
            startIcon={<ArrowBackRoundedIcon />}
            onClick={() => navigate("/")}
          >
            Back to Home
          </AppButton>
        </div>

        {!embedUrl && (
          <div className="viewerPage__status">
            Select an experience from Home to launch the embedded viewer.
          </div>
        )}

        {embedUrl && (
          <div className="viewerPage__embed">
            <iframe
              src={embedUrl}
              title="10k Web Viewer"
              loading="lazy"
              allow="camera; microphone; fullscreen"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </section>
    </main>
  );
};

export default Viewer;
